import { render, staticRenderFns } from "./Marine_fish.vue?vue&type=template&id=447af212&scoped=true"
import script from "./Marine_fish.vue?vue&type=script&lang=js"
export * from "./Marine_fish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447af212",
  null
  
)

export default component.exports